/*eslint-disable*/
import Flickity from 'flickity'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default upsells => {
  // const slideshow = upsells.querySelector('.js-upsell-carousel')
  // const leftControl = upsells.querySelector('.js-upsell-carousel-left')
  // const rightControl = upsells.querySelector('.js-upsell-carousel-right')
  // if (slideshow) {
  //   const flkty = new Flickity(slideshow, {
  //     contain: false,
  //     wrapAround: true,
  //     pageDots: false,
  //     prevNextButtons: false
  //   })

  //flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
  //flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
  //
  //   setTimeout(() => {
  //     flkty.resize()
  //   }, 1500)
  //   leftControl.addEventListener('click', () => flkty.previous())
  //   rightControl.addEventListener('click', () => flkty.next())
  // }
}



// WEBPACK FOOTER //
// ./src/scripts/components/cart-upsell.js